import CheckFeature from '../checkfeature'
import { Team } from '@/modules/teams/classes'

export default class SwitcherAnonymousGuestsFeature extends CheckFeature {
  hasFeature (): boolean {
    return this.currentTeam?.features?.switcherAnonymousGuests?.enabled ?? false
  }

  override get description (): string {
    return 'Allows anonymous guests to be added as a source in Switcher casts'
  }

  teamHasFeature (teamId: string): boolean {
    const team = this.teams[teamId]
    return team?.features?.switcherAnonymousGuests?.enabled ?? false
  }

  assignTeamFeature (team: Partial<Team>, enabled: boolean): void {
    team.features = team.features ?? {}
    team.features.switcherAnonymousGuests = { enabled }
  }

  isGlobalFeature (): boolean {
    return false
  }
}
